import { render, staticRenderFns } from "./contribute.vue?vue&type=template&id=893aa9c2&scoped=true"
import script from "./contribute.vue?vue&type=script&lang=js"
export * from "./contribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893aa9c2",
  null
  
)

export default component.exports